import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#000000FF",
    },
    primary: {
      main: "#ffa000",
    },
    secondary: {
      main: "#000",
    },
    common: {
      black: "hsla(206, 10.1%, 13.5%, 1)",
    },
  },
  typography: {
    allVariants: {
      fontFamily: "Space Mono",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "#8f8f8f",
            borderColor: "#8f8f8f",
          },
        },
        contained: {
          backgroundColor: "#000000FF",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#000000FF",
          },
          border: "1px solid #ffa000",
        },
      },
    },
  },
});
